<pr-form
  (onSubmit)="submit()"
  title="Paramétrez votre simulation"
  [formGroup]="form"
>
  <h3>Paramètres de l'investissement</h3>

  <pr-input label="Valeur du bien" suffix="€" [derrors]="derrors">
    <input formControlName="amount" type="text" />
  </pr-input>

  <pr-input label="Durée de défiscalisation" [derrors]="derrors">
    <mat-select
      formControlName="rentalCommitmentInYears"
      (selectionChange)="onRentalCommitmentInYearsChange($event)"
    >
      @for (pinelDuration of pinelDurations; track pinelDuration) {
        <mat-option [value]="pinelDuration.duration">
          {{ pinelDuration.label }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <pr-input label="Rendement locatif" suffix="%" [derrors]="derrors">
    <input formControlName="rentalReportPercentage" type="text" />
  </pr-input>

  <pr-input label="Revalorisation foncière" suffix="%" [derrors]="derrors">
    <input formControlName="propertyRevaluation" type="text" />
  </pr-input>

  <pr-input label="Revalorisation locative" suffix="%" [derrors]="derrors">
    <input formControlName="rentalRevaluation" type="text" />
  </pr-input>

  <!-- Charge -->
  <h3>Paramètres des charges</h3>

  <pr-input label="Frais de notaire" suffix="%" [derrors]="derrors">
    <input formControlName="notaryFeesPercentage" type="text" />
  </pr-input>

  <pr-input label="Taxe foncière" suffix="%" [derrors]="derrors">
    <input formControlName="estateTaxPercentage" type="text" />
  </pr-input>

  <pr-input label="Frais de gestion" suffix="%" [derrors]="derrors">
    <input formControlName="managementFeesPercentage" type="text" />
  </pr-input>

  <pr-input label="Frais de copropriété" suffix="%" [derrors]="derrors">
    <input formControlName="coOwnershipFeesPercentage" type="text" />
  </pr-input>

  <!-- Credit -->
  <h3>Paramètres du crédit</h3>

  <pr-input label="Apport" suffix="%" [derrors]="derrors">
    <input formControlName="cashPercentage" type="text" />
  </pr-input>

  <pr-input label="Durée du credit" suffix="mois" [derrors]="derrors">
    <input
      formControlName="loanDuration"
      type="text"
      (change)="onProjectDurationChange()"
    />
  </pr-input>

  <pr-input label="Taux du crédit" suffix="%" [derrors]="derrors">
    <input formControlName="loanRate" type="text" />
  </pr-input>

  <pr-input label="Frais bancaires" suffix="€" [derrors]="derrors">
    <input formControlName="bankingFees" type="text" />
  </pr-input>
</pr-form>
